export default __webpack_public_path__ + "static/media/cert-it-consumer.757943de.jpg";